import React, { Component } from 'react';
import { Route, Switch, Link, withRouter, Redirect } from 'react-router-dom'
import ReactLoading from "react-loading";
// import './Cover.css'
import Background from './background.jpeg';
import Logo from './banner.jpg';
import * as Session from './session'
import { addSurveyToFireStore, getSurveyFromFireStore } from './Config/config';
import ReactGA from 'react-ga'

class ThankYouPage extends Component {

  constructor(props) {
    super(props)
    ReactGA.pageview(window.location.pathname + window.location.search);
    this.state = {
      ...Session.currentSession,
      __isLoading: false,
      __isSaving: false,
      __shouldRedirectToRegister: false,
      __shouldRedirectToReport: false
    }
    if (!Session.isInitiated()) {
      this.state.__isLoading = true
      const { userEmail } = props.match.params
      Session.getSessionForUserEmail(userEmail).then(response => {
        this.setState({
          ...Session.currentSession,
          __isLoading: false,
          __shouldRedirectToRegister: !Session.isInitiated(),
          __shouldRedirectToReport: Session.isInitiated() && Session.isFinished()
        })
      })
    }
  }

  onCheckBoxChange(value){
    Session.currentSession.additionalContactAuthorized = value
    this.setState({
        ...Session.currentSession
    })
  }

  saveSurvey(){
    this.setState({ __isSaving: true })
    let { userEmail } = this.props.match.params
    return Session.saveCurrentSession(
      userEmail, 
      {
        isFinished: true 
      })
      .then( response => {
        this.setState({ __isSaving: false })
    })
  }

  nextUrl(){
    const { userEmail } = this.props.match.params
    return Session.reportUrl(userEmail)
  }

  tryGoingToReportUrl(){
    this.saveSurvey().then( () => {
      this.props.history.push(this.nextUrl())
    }) 
  }

  render() {
    const { userEmail } = this.props.match.params
    if (this.state.__isLoading) {
      return <LoadingPanel />
    } else if (this.state.__shouldRedirectToRegister) {
      return <Redirect to={`/user/${userEmail}/notfound`} />
    } else if (this.state.__shouldRedirectToReport) {
      return <Redirect to={Session.reportUrl(userEmail)} />
    } else if (!this.state.isFinished) {
      return <Redirect to={Session.startSubSectionUrl(userEmail)} />
    } else {
      return (
      <div className="remove-cover-wrapper text-center h-100">
        <div className="remove-cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">

          <div className="inner remove-cover">
            <p>
              <br/>
            </p>
            <p className="text-secondary">
              Concluiu as respostas às questões
            </p>
            <p className="text-secondary">
              Obrigado por ter participado
            </p>
            <p>
              <br/>
            </p>
            <p className="remove-lead">
              <Link to="#" className="btn btn-lg btn-primary" onClick={this.tryGoingToReportUrl.bind(this)}>
                Ver resultados
              </Link>
            </p>
            <p>
                <br/>
            </p>
            <p className="text-secondary">
              Os resultados apresentados em seguida serão também enviados para o seu endereço de correio {Session.currentSession.contactEmail && `(${Session.currentSession.contactEmail})`}
            </p>
            <p className="">
              <input
                type="checkbox"
                checked={this.state.additionalContactAuthorized}
                onChange={ event => this.onCheckBoxChange(event.target.checked)}
                />
                &nbsp;
                <small className="text-secondary">
                    Gostaria de ser contactado pela Nersant sobre esta temática
                </small>
            </p>
          </div>

          <footer className="mastfoot mt-auto">
            <div className="inner">
            </div>
          </footer>
        </div>
    </div>
    )}
    }
}

export default withRouter(ThankYouPage)

const LoadingPanel = (props) => (
  <div className="text-center">
      <br/>
      <span>A carregar ...</span>
      <br/>
      <br/>
      <ReactLoading type="spin" color="blue" className="mx-auto"/>
  </div>
)



// WEBPACK FOOTER //
// ./src/ThankYouPage.jsx